import { SecurableActivity } from './securable-activity';
import { UserGroup } from './user-group';
import { UserData } from './user-data';
import { ConfiguredPermissions } from './configured-permissions';
import { Customer } from './customer';
import { SecuritySettings } from './security-settings';

export class SecurityInfo {
  constructor(
    public activities: SecurableActivity[],
    public groups: UserGroup[],
    public users: UserData[],
    public configuredPermissions: ConfiguredPermissions,
    public customers: Customer[],
    public settings: SecuritySettings
  ) {}
}
